module.exports = __webpack_public_path__ + "img/5.b601c49c.jpg";